import { alpha } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { colors } from '../../assets';

interface StyleProps {
  fullScreenBackgroundColor: string;
  isShowScrollToTop: boolean;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  paperDefault: {
    [theme.breakpoints.down('xs')]: {
      '&:not(.MuiDialog-paperFullScreen)': {
        margin: 16,
      },
    },
  },
  backdropBodyNonScrollbable: {
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    overflowY: 'scroll',
    display: 'flex',
  },
  closeBtnContainer: {
    marginLeft: 'auto',
  },
  closeBtn: {
    margin: -12,
    fontSize: 12,
    color: colors.grey180,
  },

  // schedule
  scheduleContent: {
    padding: '50px 30px',
  },
  scheduleCloseBtnContainer: {
    position: 'absolute',
    top: '4px',
    right: '8px',
  },
  scheduleCloseIcon: {
    margin: '0 -10px',
  },

  // estimate
  estimateContent: {
    padding: '24px',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
    },
  },
  estimateTitle: {
    lineHeight: 1.2,
    wordBreak: 'break-word',
  },
  estimateCloseBtnContainer: {
    marginLeft: 'auto',
  },
  estimateCloseBtn: {
    margin: -12,
    fontSize: 18,
  },
  estimatePaper: {
    borderRadius: 0,
    [theme.breakpoints.down('xs')]: {
      margin: 0,
    },
  },
  customPaperScrollBody: {
    '&&': {
      maxWidth: '100%',
      margin: 0,
    },
  },
  estimatePaperScrollBody: {
    '&&': {
      margin: 32,
      height: 'auto',
      maxHeight: '90vh',
    },
  },

  // basic
  basicContent: {
    height: '100%',
    padding: '8px 16px 16px 16px',
  },
  basicContentInner: {
    height: '100%',
  },
  basicHeader: {
    zIndex: 1,
  },
  basicTitleContainer: {
    paddingBottom: '8px',
  },
  basicChildrenContainer: {
    height: '100%',
    paddingTop: '8px',
  },

  // withSeparator
  withSeparatorContent: {
    padding: '24px',
  },
  withSeparatorTitleContainer: {
    paddingBottom: '24px',
  },
  withSeparatorChildrenContainer: {
    paddingTop: '16px',
  },
  separatorContainer: {
    margin: '0 -24px',
  },

  // fullScreen
  fullScreenPaper: {
    backgroundColor: ({ fullScreenBackgroundColor }) => fullScreenBackgroundColor,
  },
  fullScreenHeader: {
    position: 'sticky',
    top: 0,
    margin: '0px -64px',
    padding: '24px 64px',
    zIndex: 1000,
    background: `linear-gradient(to bottom, ${colors.grey10} 30%, ${alpha(colors.grey10, 0)} 100%)`,

    [theme.breakpoints.down('sm')]: {
      margin: '0px -20px',
      padding: '24px 20px',
    },
  },
  fullScreenContent: {
    padding: '0px 64px 24px',
    overflowY: 'auto',

    [theme.breakpoints.down('sm')]: {
      padding: '0px 20px 24px',
    },
  },
}));
